export const PUBLICATION_TIME_ZONE = "America/New_York";

export function getPublicationDate(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: PUBLICATION_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const values = Object.fromEntries(
    parts.filter(({ type }) => type !== "literal").map(({ type, value }) => [type, value])
  );

  return `${values.year}-${values.month}-${values.day}`;
}

export function isArticlePublished(article, now = new Date()) {
  const publicationDate = String(article?.date || "").slice(0, 10);
  return Boolean(publicationDate) && publicationDate <= getPublicationDate(now);
}

export function filterPublishedArticles(articles, now = new Date()) {
  return articles.filter((article) => isArticlePublished(article, now));
}
